<template>
  <div>
    <div class="container-buttons">
      <div class="container-buttons-start">
        <button
          class="btn-custom btn-info mb-3"
          @click="invokeFileInputClick"
        >
          <i class="fa fa-upload"></i> Importar Lista
        </button>
        <button
          v-show="file"
          class="btn-custom btn-cobranca mb-3 ml-2"
          @click="sendSms"
        >
          <i class="fa fa-paper-plane"></i> Enviar SMS
        </button>
        <input
          type="file"
          @change="onSelectFile"
          accept=".csv"
          class="hidden"
          id="fileInput"
        />
      </div>
    </div>
    <card
      :title="`Pré-visualização (${fileContent.length})`"
      subTitle="Usuários que receberão a mensagem"
      v-show="fileContent.length > 0"
    >
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>Nome</th>
            <th>Telefone(s)</th>
          </thead>
          <tbody>
            <tr v-for="client in paginatedPreview" :key="client.id">
              <td>{{ client.name || "-" }}</td>
              <td>{{ client.phones.join(",") || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="paginationPreview.currentPage"
      :totalPages="paginationPreview.totalPages"
      v-on:update="updatePaginationPreview"
    />

    <form>
        <div class="form-group">
          <label for="exampleFormControlTextarea1"
            >Digite o assunto do SMS</label
          >
          <input
            v-model="subject"
            class="form-control i-width"
          />
        </div>
        <div class="form-group">
          <label for="exampleFormControlTextarea1"
            >Escolha o provedor de envio</label
          >
          <select v-model="provider" class="form-control input i-width">
            <option value="smsimple">Chipeira</option>
            <option value="smsgestor">SMSGestor</option>
            <option value="disparopro">Disparo Pro</option>
            </select>
        </div>
      <div class="form-group">
        <label for="exampleFormControlTextarea1"
          >Digite abaixo a mensagem do SMS</label
        >
        <textarea
          v-model="message"
          class="form-control"
          id="exampleFormControlTextarea1"
          rows="5"
        ></textarea>
      </div>
      <div v-if="vars.length > 0">
        <p v-pre>Para usar váriaveis use {{ variavel }} no meio da mensagem.</p>
        <p>Variáveis disponíveis: {{ vars.join(', ') }}</p>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import * as csvtojson from "csvtojson";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination,
  },
  computed: {
    paginatedPreview() {
      return this.fileContent.slice(
        (this.paginationPreview.currentPage - 1) *
          this.paginationPreview.perPage,
        this.paginationPreview.currentPage * this.paginationPreview.perPage
      );
    },
  },
  data() {
    return {
      file: null,
      provider: 'disparopro',
      fileContent: [],
      message: '',
      subject: '',
      numbers: [],
      vars: [],
      content: [],
      paginationPreview: {
        totalPages: 1,
        currentPage: 1,
        perPage: 5,
      },
    };
  },
  methods: {
    ...mapActions(["sendSMS"]),
    onSelectFile(evt) {
      const reader = new FileReader();
      reader.onload = async () => {
        const csvPromise = csvtojson({
          delimiter: "auto",
        })
          .fromString(reader.result)
          .then((result) => Promise.resolve(result));

        const results = await csvPromise;

        if (results.length === 0) {
          input.value = null;
          Swal.fire("Ops!", "O arquivo deve ter pelo menos uma linha.", "error");
          return;
        }

        this.vars = Object.keys(results[0]);
        this.content = results;
        this.fileContent = results.map((r) => {
          return {
            name: r["Nome do Assinante"],
            phones: r.Tel,
          };
        });

        this.paginationPreview.totalPages = Math.floor(
          (this.fileContent.length - 1) / this.paginationPreview.perPage + 1
        );

        if (this.fileContent.length === 0) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível concluir esta ação, verifique se o arquivo é válido",
            icon: "error",
          });
          this.clearSelectedFile();
        }
      };
      this.file = evt.target.files[0];
      if (this.file) {
        reader.readAsBinaryString(this.file);
      } else {
        this.fileContent = [];
        this.paginationPreview.totalPages = Math.floor(
          (this.fileContent.length - 1) / this.paginationPreview.perPage + 1
        );
      }
    },
    clearSelectedFile() {
      const input = document.getElementById("fileInput");
      input.value = "";
      this.file = null;
      this.vars = [];
      this.content = [];
      this.fileContent = [];
      this.paginationPreview.totalPages = Math.floor(
        (this.fileContent.length - 1) / this.paginationPreview.perPage + 1
      );
    },
    invokeFileInputClick() {
      const input = document.getElementById("fileInput");
      const clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      input.dispatchEvent(clickEvent);
    },
    async sendSms() {
      if (!this.message) {
        Swal.fire({
          title: "Ops!",
          text: "A mensagem não pode ser vazia",
          icon: "error",
        });
        return;
      }

      const phones = [];
      this.fileContent.forEach(c => c.phones.forEach(p => {
        if (p && !phones.includes(p)) {
          phones.push(p);
        }
      }));

      if (phones.length === 0) {
        Swal.fire({
          title: "Ops!",
          text: "Precisa existir pelo menos 1 telefone para enviar o SMS",
          icon: "error",
        });
        return;
      }

      if (!this.subject) {
        Swal.fire({
          title: "Ops!",
          text: "O assunto não pode ser vazio",
          icon: "error",
        });
        return;
      }

      const result = await Swal.fire({
        title: "Atenção!",
        text: "Esta ação irá enviar uma mensagem SMS para os telefones do arquivo, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      });

      if (result.isConfirmed) {
        Swal.fire({
            title: 'Aguarde...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            onOpen: async () => {
              try {
                Swal.showLoading();

                if (this.message.includes('{{') && this.message.includes('}}')) {
                  if (this.provider !== 'smsimple') {
                    Swal.fire({
                      title: "Ops!",
                      text: "Esse provedor não suporta esse envio",
                      icon: "error",
                    });
                    return;
                  }

                  const data = [];
                  this.content.forEach(c => {
                    let text = this.message;
                    this.vars.forEach(v => {
                      const regex = new RegExp(`{{\\s*${v}\\s*}}`, 'gi');
                      const value = c[v];
                      text = text.replace(regex, value);
                    });

                    const phones = c.Tel.map(t => '11' + t).filter(t => t.length === 11);

                    data.push({ numbers: phones, text });
                  });

                  await this.sendSMS(data);
                } else {
                  await this.sendSMS({
                    numbers: phones,
                    message: this.message,
                    subject: this.subject,
                    provider: this.provider,
                  });
                }

                Swal.fire({
                  title: "Sucesso!",
                  text: "Os SMS foram enviados",
                  icon: "success",
                });
              } catch (err) {
                console.log(err);
                Swal.fire({
                  title: "Ops!",
                  text: "Não foi possível concluir esta ação, verifique se o arquivo é válido",
                  icon: "error",
                });
              } finally {
                this.clearSelectedFile();
              }
            }
          });
      }
    },
    async updatePaginationPreview({ currentPage }) {
      this.paginationPreview.currentPage = currentPage;
    },
  },
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}
.modal-title {
  font-size: 20px;
}
.btn-modal {
  padding: 10px 60px;
}
.container-body {
  display: flex;

  p {
    font-size: 16px;
  }
}
.container-buttons {
  display: flex;

  a {
    cursor: pointer;
  }
}

.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-stop-cobranca {
    background: #b80a0a;

    &:hover {
      background: #700202;
    }
  }

  &.btn-modal {
    padding: 10px 50px;
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}

.btn-outline-warning {
  border-color: #ffc107;
  color: #ffc107;

  &:hover {
    background: #ffc107 !important;
    background-color: #ffc107 !important;
    border-color: #ffc107;
  }
}

.modalPhones {
  ul {
    font-size: 16px;
    li {
      list-style: none;
    }
  }
}
</style>
<style>
input.i-width, select.i-width {
  width: 30em;
}
@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
  input.i-width, select.i-width {
  width: 20em;
}
}

</style>
